export const TREATMENT_QUOTATION_CREATED_DE = `
Hallo $salutation $lastName,

Ihr individueller Behandlungsplan ist fertig. Dieser wurde für Sie in ihrem persönlichen Account auf unserer Website $websiteUrl hinterlegt und per E-Mail an Sie gesendet.
Der Behandlungsplan enthält eine 3D-Simulation, die Ihnen zeigt, wie Ihre Zähne am Ende der Behandlung aussehen werden. Sollten Sie Fragen dazu haben, antworten Sie gerne auf diese Whatsapp oder rufen uns unter +49 (0) 30 255 585 825 an.

Viele Grüße
Ihr PlusDental-Team
`

export const TREATMENT_QUOTATION_CREATED_GB = `
Hello $salutation $lastName,

Your individual treatment plan is ready. This is available for you to see in your account at our website $websiteUrl and we have also sent it to you by e-mail.

The treatment plan includes a 3D simulation that shows you how your teeth will look at the end of the treatment. If you have any questions, please feel free to contact our customer service. Via e-mail: $emailAddress or via phone +44 20 3499 8279 (Mon-Fri 8am-7pm, Sat 9am-5pm).

Best regards
Your PlusDent Team
`

export const TREATMENT_QUOTATION_CREATED_CH = `
Hallo $salutation $lastName,

eventuell hatten Sie die Gelegenheit Ihren Behandlungsplan einzusehen und sind von dem geplanten Behandlungsergebnis begeistert?

Dann möchten wir Ihnen gerne einen Gutschein-Code zur Verfügung stellen, mit dem Sie bei der Bestellung der Zahnschienen 300CHF sparen. Geben Sie hierfür einfach den Gutschein-Code undefined bei der Bestellung der Zahnschienen ein.

Ihren individuellen Behandlungsplan finden Sie in Ihrem persönlichen Account auf unserer Website https://www.plusdental.ch/account/checkout-treatment

Lassen Sie uns gerne wissen, wenn Sie noch Fragen zu Ihrer Behandlung haben. Sie erreichen uns telefonisch unter +41 44 505 12 36 oder per E-Mail an info@plusdental.ch

Viele Grüße
Ihr PlusDental-Team
`

export const TREATMENT_QUOTATION_REMINDER_DE = `
Hallo $salutation $lastName,

vor einiger Zeit haben Sie Ihren individuellen Behandlungsplan per E-Mail erhalten. Sollten Sie diesen mit unseren Experten besprechen wollen, können Sie einen kostenlosen Termin für ein Telefongespräch vereinbaren, um alle offenen Fragen zu beantworten. Zur Terminvereinbarung: https://calendly.com/medical-team-plusdental/30min. 

Ihren Behandlungsplan finden Sie auch in Ihrem persönlichen Account auf unserer Website $websiteUrl/account/checkout-treatment
Viele Grüße
Ihr PlusDental-Team
`

export const TREATMENT_QUOTATION_REMINDER_GB = `
Hello $salutation $lastName,

A short while ago, you received your individual treatment plan by e-mail. Should you wish to discuss this with our experts, you can arrange a free appointment for a telephone conversation to discuss details with us (+44 20 3499 8279 Mon-Fri 8am-7pm, Sat 9am-5pm).

Your treatment plan can also be found in your account on our website $websiteUrl

Best regards
Your PlusDent Team
`

export const TREATMENT_QUOTATION_REMINDER2_DE = `
Hallo $salutation $lastName,

gerne möchten wir Sie noch einmal an Ihren individuellen Behandlungsplan erinnern, den wir Ihnen per E-Mail zugeschickt haben. Diesen finden Sie auch in Ihrem persönlichen Account auf $websiteUrl. Dort sehen Sie, anhand einer 3D-Simulation, wie sich Ihre Zähne in die gewünschte Position verschieben werden.

Sollten Sie weitere Informationen benötigen oder Fragen zu Ihrer Behandlung haben, lassen Sie es uns gerne wissen. Sie erreichen uns unter +49 (0) 30 255 585 825 oder per E-Mail an $emailAddress



Viele Grüße
Ihr PlusDental-Team
`

export const TREATMENT_QUOTATION_REMINDER2_CH = `
Hallo $salutation $lastName,

gerne möchten wir Sie noch einmal an Ihren individuellen Behandlungsplan erinnern, den wir Ihnen per E-Mail zugeschickt haben. Diesen finden Sie auch in Ihrem persönlichen Account auf $websiteUrl. Dort sehen Sie, anhand einer 3D-Simulation, wie sich Ihre Zähne in die gewünschte Position verschieben werden.

Sollten Sie weitere Informationen benötigen oder Fragen zu Ihrer Behandlung haben, lassen Sie es uns gerne wissen. Sie erreichen uns unter +41 44 505 12 36 oder per E-Mail an $emailAddress



Viele Grüße
Ihr PlusDental-Team
`

export const TREATMENT_QUOTATION_REMINDER2_GB = `
Hello $salutation $lastName,

We would like to remind you about your individual treatment plan that we have sent to you by email. You can find it in your account on $websiteUrl. There you see how your teeth will shift to the desired position using a 3D simulation.

If you have any questions, please feel free to contact our customer service. Via e-mail: $emailAddress or via phone +44 20 3499 8279 (Mon-Fri 8am-7pm, Sat 9am-5pm).

Best regards
Your PlusDent-Team
`

export const TREATMENT_QUOTATION_REMINDER_VOUCHER_DE = `
Hallo $salutation $lastName,

eventuell hatten Sie die Gelegenheit Ihren Behandlungsplan einzusehen und sind von dem geplanten Behandlungsergebnis begeistert?

Dann möchten wir Ihnen gerne einen Gutschein-Code zur Verfügung stellen, mit dem Sie bei der Bestellung der Zahnschienen 300€ sparen. Geben Sie hierfür einfach den Gutschein-Code $voucherCode bei der Bestellung der Zahnschienen ein.

Ihren individuellen Behandlungsplan finden Sie in Ihrem persönlichen Account auf unserer Website $websiteUrl

Lassen Sie uns gerne wissen, wenn Sie noch Fragen zu Ihrer Behandlung haben. Sie erreichen uns telefonisch unter +49 (0) 30 255 585 825 oder per E-Mail an $emailAddress

Viele Grüße
Ihr PlusDental-Team
`

export const TREATMENT_QUOTATION_REMINDER_VOUCHER_CH = `
Hallo $salutation $lastName,

eventuell hatten Sie die Gelegenheit Ihren Behandlungsplan einzusehen und sind von dem geplanten Behandlungsergebnis begeistert?

Dann möchten wir Ihnen gerne einen Gutschein-Code zur Verfügung stellen, mit dem Sie bei der Bestellung der Zahnschienen 300€ sparen. Geben Sie hierfür einfach den Gutschein-Code $voucherCode bei der Bestellung der Zahnschienen ein.

Ihren individuellen Behandlungsplan finden Sie in Ihrem persönlichen Account auf unserer Website $websiteUrl

Lassen Sie uns gerne wissen, wenn Sie noch Fragen zu Ihrer Behandlung haben. Sie erreichen uns telefonisch unter +41 44 505 12 36 oder per E-Mail an $emailAddress

Viele Grüße
Ihr PlusDental-Team
`

export const TREATMENT_QUOTATION_REMINDER_VOUCHER_GB = `
Hello $salutation $lastName,

Perhaps you have had the opportunity to review your treatment plan and are enthusiastic about the planned treatment result?

Then we would like to provide you with a voucher code that will save you 300 GBP when ordering your PlusDent Treatment. Simply enter the voucher code $voucherCode when ordering. You will find your individual treatment plan in your personal account on our website $websiteUrl.

If you have any questions, please do not hesitate to contact our customer service.Via e-mail: $emailAddress or via phone +44 20 3499 8279 (Mon-Fri 8am-7pm, Sat 9am-5pm).

Best regards
Your PlusDent-Team
`



// WEBPACK FOOTER //
// ./src/modules/sales-order/resources/whatsAppMacros.js